import { useMemo, useSyncExternalStore } from 'react';
import { apiFetch } from '../utils/api';
const stores=new Map();
export function clearNotificationStores(){for(const store of stores.values())store.stop();stores.clear();}
function createStore() {
  let state={notifications:[],unreadCount:0,loading:true,error:'',revision:0};
  let pending, timer, generation=0;
  const listeners=new Set();
  const publish=patch=>{state={...state,...patch};listeners.forEach(fn=>fn());};
  async function refresh(){
    if(pending)return pending;
    const version=generation;
    const request=(async()=>{
      const data=await apiFetch('/api/notifications?limit=100');
      if(version!==generation)return;
      publish(data.ok?{notifications:data.notifications,unreadCount:data.unreadCount,loading:false,error:'',revision:state.revision+1}
        :{loading:false,error:data.message||'Could not load notifications.'});
    })();
    pending=request;
    request.finally(()=>{if(pending===request)pending=null;});
    return request;
  }
  const focus=()=>{if(document.visibilityState==='visible')refresh();};
  const pushed=event=>{if(event.data?.type==='notification-arrived')refresh();};
  function stop(){generation++;pending=null;clearInterval(timer);window.removeEventListener('focus',focus);document.removeEventListener('visibilitychange',focus);navigator.serviceWorker?.removeEventListener('message',pushed);}
  const store={getSnapshot:()=>state,refresh,stop,
    subscribe(listener){listeners.add(listener);if(listeners.size===1){refresh();timer=setInterval(focus,60000);window.addEventListener('focus',focus);document.addEventListener('visibilitychange',focus);navigator.serviceWorker?.addEventListener('message',pushed);}return()=>{listeners.delete(listener);if(!listeners.size)stop();};},
    async markRead(id){const data=await apiFetch(`/api/notifications/${encodeURIComponent(id)}/read`,{method:'PATCH'});if(!data.ok){publish({error:data.message||'Could not mark this notification read.'});return false;}
      const wasUnread=state.notifications.some(n=>String(n.id)===String(id)&&!n.read);
      publish({notifications:state.notifications.map(n=>String(n.id)===String(id)?{...n,read:true}:n),unreadCount:Math.max(0,state.unreadCount-(wasUnread?1:0)),revision:state.revision+1,error:''});refresh();return true;},
    async markAllRead(){const data=await apiFetch('/api/notifications/read-all',{method:'PATCH'});if(!data.ok){publish({error:data.message||'Could not mark notifications read.'});return false;}
      publish({notifications:state.notifications.map(n=>({...n,read:true})),unreadCount:0,error:'',revision:state.revision+1});return true;},
  };
  return store;
}
export function useNotifications(userId){
  const store=useMemo(()=>{const key=String(userId);if(!stores.has(key))stores.set(key,createStore());return stores.get(key);},[userId]);
  const state=useSyncExternalStore(store.subscribe,store.getSnapshot);
  return {...state,refresh:store.refresh,markRead:store.markRead,markAllRead:store.markAllRead};
}
